module.exports = __webpack_public_path__ + "img/me2.8d5c5222.jpg";